// extracted by mini-css-extract-plugin
export default {"root":"datepicker_root__sGQ8V"};